import { IExchangeModel } from 'src/app/logic/exchanges/model/exchange.model';

export type PromotionOperationType = 'buy' | 'sell';

export function getRegularRate(
  buyPrice: number | undefined | null,
  sellPrice: number | undefined | null,
  operationType: PromotionOperationType,
): number | null {
  const price =
    operationType === 'sell'
      ? buyPrice != null
        ? Number(buyPrice)
        : null
      : sellPrice != null
        ? Number(sellPrice)
        : null;

  if (price === null || Number.isNaN(price)) {
    return null;
  }

  return price;
}

/** promotionPrice is the MXN discount per unit, not the final rate. */
export function getEffectivePromotionRate(
  regularRate: number,
  promotionPrice: number,
  operationType: PromotionOperationType,
): number {
  const discount = Number(promotionPrice);
  if (Number.isNaN(discount)) {
    return regularRate;
  }

  return operationType === 'sell'
    ? regularRate + discount
    : regularRate - discount;
}

export function applyEffectivePromotionRate(
  exchange: IExchangeModel,
  operationType: PromotionOperationType,
  promotionPrice: number,
): IExchangeModel {
  const regularRate =
    operationType === 'sell' ? Number(exchange.buy) : Number(exchange.sell);
  const effectiveRate = getEffectivePromotionRate(
    regularRate,
    promotionPrice,
    operationType,
  );

  return {
    ...exchange,
    currency: { ...exchange.currency },
    buy: operationType === 'sell' ? effectiveRate : exchange.buy,
    sell: operationType === 'buy' ? effectiveRate : exchange.sell,
  };
}

export interface PromotionExchangeRateLike {
  id?: number;
  buyPrice?: number;
  sellPrice?: number;
  currency?: {
    id?: number;
    name?: string;
    fullName?: string;
    code?: string;
  };
}

export function mapPromotionExchangeToModel(
  rate: PromotionExchangeRateLike,
): IExchangeModel {
  return {
    id: rate.id ?? 0,
    buy: Number(rate.buyPrice ?? 0),
    sell: Number(rate.sellPrice ?? 0),
    active: true,
    updateAt: '',
    currency: {
      id: rate.currency?.id ?? 0,
      name: rate.currency?.name ?? '',
      fullName: rate.currency?.fullName ?? '',
      code: rate.currency?.code ?? rate.currency?.name ?? '',
    },
  };
}
